/* eslint-disable react/prop-types */
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export function DefaultDialog({
  isOpen,
  onClose,
  title = "View Details",
  cancelButtonText = "Cancel",
  confirmButtonText = "Confirm",
  children,
  hideButtons = false,
  className = " max-w-[420px]",
}) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className={className}>
        <DialogHeader className={`flex justify-center items-center gap-2`}>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className=" w-full h-full">
          {children}
        </div>
        <DialogFooter>
          {!hideButtons && (
            <div className={`flex w-full justify-center gap-5 items-center`}>
              <Button className="w-full bg-color14" onClick={onClose}>{cancelButtonText}</Button>
              <Button className="w-full bg-color14" onClick={onClose}>{confirmButtonText}</Button>
            </div>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
